export enum HourToRunEnum {
  ONE_AM = '1 AM',
  TWO_AM = '2 AM',
  THREE_AM = '3 AM',
  FOUR_AM = '4 AM',
  FIVE_AM = '5 AM',
  SIX_AM = '6 AM',
  SEVEN_AM = '7 AM',
  EIGHT_AM = '8 AM',
  NINE_AM = '9 AM',
  TEN_AM = '10 AM',
  ELEVEN_AM = '11 AM',
  NOON = '12 PM',
  ONE_PM = '1 PM',
  TWO_PM = '2 PM',
  THREE_PM = '3 PM',
  FOUR_PM = '4 PM',
  FIVE_PM = '5 PM',
  SIX_PM = '6 PM',
  SEVEN_PM = '7 PM',
  EIGHT_PM = '8 PM',
  NINE_PM = '9 PM',
  TEN_PM = '10 PM',
  ELEVEN_PM = '11 PM',
  MIDNIGHT = '12 AM',
}
